"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePvs = exports.pvsData = exports.resultsDefinition = void 0;
const functions_1 = require("../functions");
const property_1 = require("@genesys/property");
// Every value CoilPro returns for this coil, under CoilPro's own names, so one vocabulary runs
// from the DLL through the schema to the translation key. Errors and warnings are comma-joined
// strings; a coil can calculate successfully and still warn, so an empty warnings cell is the
// only clean result.
exports.resultsDefinition = [
    {
        sortNo: 10,
        propertyName: "errors"
    },
    {
        sortNo: 20,
        propertyName: "warnings"
    },
    {
        sortNo: 30,
        propertyName: "airpressuredrop"
    },
    {
        sortNo: 40,
        propertyName: "airpressuredropdry"
    },
    {
        sortNo: 50,
        propertyName: "airtotalcapacity"
    },
    {
        sortNo: 60,
        propertyName: "temperatureout"
    },
    {
        sortNo: 70,
        propertyName: "humidityout"
    },
    {
        sortNo: 80,
        propertyName: "pressureout"
    },
    {
        sortNo: 90,
        propertyName: "flow"
    },
    {
        sortNo: 100,
        propertyName: "airvelocity"
    },
    {
        sortNo: 110,
        propertyName: "airstandardvelocity"
    },
    {
        sortNo: 120,
        propertyName: "condensedwater"
    },
    {
        sortNo: 130,
        propertyName: "sensibletotalcapacityratio"
    },
    {
        sortNo: 140,
        propertyName: "marginal"
    },
    {
        sortNo: 150,
        propertyName: "condensingpressure"
    },
    {
        sortNo: 160,
        propertyName: "evaporationpressure"
    },
    {
        sortNo: 170,
        propertyName: "totalfreonpressuredrop"
    },
    {
        sortNo: 180,
        propertyName: "freongaspressuredrop"
    },
    {
        sortNo: 190,
        propertyName: "freonliquidpressuredrop"
    },
    {
        sortNo: 200,
        propertyName: "freonmixedpressuredrop"
    },
    {
        sortNo: 210,
        propertyName: "freonmassflow"
    },
    {
        sortNo: 220,
        propertyName: "freoninletconnectionvelocity"
    },
    {
        sortNo: 230,
        propertyName: "freonoutletconnectionvelocity"
    },
    {
        sortNo: 240,
        propertyName: "freonliquidvelocity"
    },
    {
        sortNo: 250,
        propertyName: "freongasvelocity"
    }
];
const pvsData = (result) => ({
    errors: result.errors,
    warnings: result.warnings,
    airpressuredrop: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.airPressureDrop)),
    airpressuredropdry: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.airPressureDropDry)),
    airtotalcapacity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.airTotalCapacity)),
    temperatureout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.temperatureOut)),
    humidityout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.humidityOut)),
    pressureout: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.pressureOut)),
    flow: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.flow)),
    airvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.airVelocity)),
    airstandardvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.airStandardVelocity)),
    condensedwater: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.condensedWater)),
    sensibletotalcapacityratio: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.sensibleTotalCapacityRatio)),
    marginal: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.marginal)),
    condensingpressure: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.condensingPressure)),
    evaporationpressure: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.evaporationPressure)),
    totalfreonpressuredrop: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.totalFreonPressureDrop)),
    freongaspressuredrop: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.freonGasPressureDrop)),
    freonliquidpressuredrop: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.freonLiquidPressureDrop)),
    freonmixedpressuredrop: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.freonMixedPressureDrop)),
    freonmassflow: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.freonMassFlow)),
    freoninletconnectionvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.freonInletConnectionVelocity)),
    freonoutletconnectionvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.freonOutletConnectionVelocity)),
    freonliquidvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.freonLiquidVelocity)),
    freongasvelocity: property_1.PropertyValue.getAmount(property_1.PropertyValue.fromString(result.freonGasVelocity)),
});
exports.pvsData = pvsData;
const makePvs = (result) => (0, functions_1.collectResults)((0, exports.pvsData)(result));
exports.makePvs = makePvs;
//# sourceMappingURL=results-definition.js.map